<template>
  <div>
    <section class="wf100 subheader" style="background: var(--info)">
      <div class="container">
        <h2>معلومات الخبر</h2>
        <ul>
          <li><router-link to="/" href="#">الرئيسية</router-link></li>
          <li>المنظمة</li>
          <li>معلومات الخبر</li>
        </ul>
      </div>
    </section>

    <!--Sub Header End-->
    <!--Main Content Start-->
    <div class="main-content mt-2">
      <div v-if="loadingNgo">
        <b-skeleton height="400px"></b-skeleton>
        <swiper class="swiper-responsive-breakpoints" :options="swiperOptions">
          <swiper-slide v-for="n in 6" :key="n">
            <b-skeleton height="250px" width="250px" class="mx-1"></b-skeleton
          ></swiper-slide>
        </swiper>
      </div>
      <!--News Details Page Start-->
      <div v-else class="news-details">
        <div style="max-width: 1200px; margin: auto">
          <div class="row">
            <!--Content Col Start-->
            <div class="col-md-12">
              <div class="event-details">
                <img
                  :src="ngoNews.image"
                  width="100%"
                  style="max-height: 675px; object-fit: cover"
                  height="auto"
                />
                <!--Counter-->
                <!--Counter End-->
                <!--Event Details text-->
                <div class="event-content mt-1">
                  <h4>{{ ngoNews.title_ar }}</h4>
                  <hr />
                  <!--Date and Share Start-->
                  <!-- <div class="event-date-share">
                    <div class="edate">
                      <strong>{{ ngoNewsaccomplished_at }}</strong>
                    </div>
                  </div> -->
                  <!--Date and Share End-->
                  <div class="etext">
                    <ul class="emeta">
                      <li>
                        <strong>المحافظة:</strong>
                        {{ ngoNews.governorate.name_ar }}
                      </li>
                    </ul>
                    <p style="text-align: justify">
                      {{ ngoNews.description_ar }}
                    </p>
                  </div>
                </div>

                <div
                  class="event-gallery"
                  v-if="ngoNews.newSlides.length !== 0"
                >
                  <h3>معرض النشاط</h3>
                  <swiper
                    class="swiper-responsive-breakpoints"
                    :options="swiperOptions"
                    v-if="ngoNews.newSlides.length > 0"
                  >
                    <swiper-slide
                      v-for="(data, index) in ngoNews.newSlides"
                      :key="index"
                    >
                      <b-img
                        :src="data.image"
                        fluid
                        style="width: 100%; height: 175px"
                      />
                    </swiper-slide>
                    <div
                      slot="button-next"
                      class="swiper-button-next"
                      style="color: #fff"
                    />
                    <div
                      slot="button-prev"
                      class="swiper-button-prev"
                      style="color: #fff"
                    />
                    <div slot="pagination" class="swiper-pagination" />
                  </swiper>
                  <alert v-else :massage="$t('alert')" class="w-100"></alert>
                </div>

                <div
                  v-if="ngoNews.video"
                  class="justify-center-center"
                  align="center"
                >
                  <div class="video_mine">
                    <video alt="" class="mt-2 video_news" controls>
                      <source :src="ngoNews.video" type="video/mp4" />
                      <source :src="ngoNews.video" type="video/ogg" />
                    </video>
                  </div>
                </div>
              </div>
            </div>
            <!--Content Col End-->
            <!--Sidebar Start-->

            <!--Sidebar End-->
          </div>
        </div>
      </div>
      <!--News Details Page End-->
    </div>
    <!--Main Content End-->
  </div>
</template>

<script>
import NgoHeader from "../../components/NgoHeader.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import {
  BTable,
  BButton,
  BFormInput,
  BFormTextarea,
  BNav,
  BNavItem,
  BSkeleton,
  BImg,
} from "bootstrap-vue";
import { mapGetters } from "vuex";
export default {
  components: {
    BTable,
    BButton,
    BFormInput,
    BFormTextarea,
    BNav,
    BNavItem,
    NgoHeader,
    Swiper,
    SwiperSlide,
    BSkeleton,
    BImg,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 5,
        spaceBetween: 50,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          320: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      navItems: [
        {
          title: "الإتفاقيات  والشراكات",
          route: "form-layout",
          icon: "CopyIcon",
        },
        {
          title: "الإتفاقيات  والشراكات",
          route: "form-layout",
          icon: "CopyIcon",
        },
      ],
      items: [
        {
          number: 123213,
          name: "Dickerson",
        },
        {
          number: 51235,
          name: "Larsen",
        },
        {
          number: 612466,
          name: "Larsen",
        },
      ],
      currentPage: 1,
    };
  },
  computed: {
    ...mapGetters("NgoHome/newsNgo", ["ngoNews", "loadingNgo"]),
  },
  created() {
    this.$store.dispatch("NgoHome/newsNgo/getNgoNews", {
      id: this.$route.params.activityId,
    });
  },
};
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/horizontal-menu.scss";

.h3-logo-row .h3-logo {
  padding: 2px !important;
  // text-align: justify;
}

.video_news {
  width: 750px !important;
  height: 420px !important;
}

@media (max-width: 648px) {
  .video_news {
    width: 100% !important;
    height: 420px !important;
  }
}
</style>
